var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53125 0.66626H13.0995C14.296 0.66626 15.2659 1.63619 15.2659 2.83266V12.9425C15.2659 14.139 14.296 15.1089 13.0995 15.1089H3.53125",
    stroke: "#2F695D",
    strokeWidth: 0.938772
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28012 7.97009C9.46342 7.78678 9.46342 7.48958 9.28012 7.30628L6.29296 4.31912C6.10966 4.13581 5.81246 4.13581 5.62915 4.31912C5.44584 4.50243 5.44584 4.79963 5.62915 4.98293L8.2844 7.63818L5.62915 10.2934C5.44584 10.4767 5.44584 10.7739 5.62915 10.9572C5.81246 11.1406 6.10966 11.1406 6.29296 10.9572L9.28012 7.97009ZM0.824219 8.10757L8.94821 8.10757L8.94821 7.1688L0.824219 7.1688L0.824219 8.10757Z",
    fill: "#2F695D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/login_icon.8c4ba5849416e72a384143d5108920bf.svg";
export { ForwardRef as ReactComponent };